"use strict";
/*
 * This file is part of ORY Editor.
 *
 * ORY Editor is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * ORY Editor is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with ORY Editor.  If not, see <http://www.gnu.org/licenses/>.
 *
 * @license LGPL-3.0
 * @copyright 2016-2018 Aeneas Rekkas
 * @author Aeneas Rekkas <aeneas+oss@aeneas.io>
 *
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var ThemeProvider_1 = require("ory-editor-ui/lib/ThemeProvider");
var ory_editor_ui_1 = require("ory-editor-ui");
var state_1 = require("../default/state");
var Form = function (props) {
    var Renderer = props.Renderer, focused = props.focused, changeSrcPreview = props.changeSrcPreview, commitSrc = props.commitSrc, label = props.label, placeholder = props.placeholder, readOnly = props.readOnly, _a = props.state, src = (_a === void 0 ? state_1.defaultVideoState : _a).src;
    return (React.createElement("div", null,
        React.createElement(Renderer, __assign({}, props)),
        !readOnly && focused && (React.createElement(ory_editor_ui_1.BottomToolbar, { open: focused, theme: ThemeProvider_1.darkTheme },
            React.createElement(TextField_1.default, { placeholder: placeholder, label: label, style: { width: '512px' }, value: src, onChange: function (e) { return changeSrcPreview(e.target.value); }, onBlur: commitSrc })))));
};
exports.default = Form;
//# sourceMappingURL=VideoDefaultControls.js.map